import { ExclamationTriangleIcon } from '@radix-ui/react-icons';
import { Callout } from '@scale/scaleui-radix';
import _ from 'lodash';
import HTTPError from 'react-scale/lib/httpError';

const LinterError: React.FC<{ error: unknown }> = ({ error }) => {
  let message = '';

  if (error instanceof HTTPError) {
    message = `${error.status}: ${error.response?.error}`;
  } else if (error instanceof Error) {
    message = error.message;
  } else if (_.isString(error)) {
    message = error;
  }

  return (
    <Callout.Root color="error" role="alert">
      <Callout.Icon>
        <ExclamationTriangleIcon />
      </Callout.Icon>
      <Callout.Text>Something went wrong: {message}</Callout.Text>
    </Callout.Root>
  );
};

export default LinterError;
